import { TinyDropdownMenu } from '@octopus-do/octopus-storybook'
import { Pen, Trash } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

interface Props {
  canEdit: boolean
  canDelete: boolean
}

export const Content: React.FC<Props> = ({ canEdit, canDelete }) => (
  <TinyDropdownMenu.Group>
    {canEdit && <TinyDropdownMenu.Button id="edit" label="Edit" icon={Pen} />}
    {canDelete && (
      <TinyDropdownMenu.Button
        id="delete"
        label="Delete"
        icon={Trash}
        variant="danger"
      />
    )}
  </TinyDropdownMenu.Group>
)
